import styled from 'styled-components';

const Wrapper = styled.div`
  height: 690px;
  width: 830px;

  iframe {
    border: none;
  }
`;

export const OnboardingCall = () => (
  <Wrapper>
    <iframe
      title="hubspot-calendar"
      style={{
        width: '100%',
        height: '100%',
      }}
      src={'https://meetings.hubspot.com/nick-gibbons?embed=true'}
    />
  </Wrapper>
);
